export default class formConfig {
  // 企业登记信息 项目信息模块
  static projectInformation() {
    return [
      {
        title: "自行招标",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目编号：",
            value: "constructionNo",     
            type: "slot",
            slotName: "constructionNo",
            class: "constructionNo itemBtn",
            disabled: true,
          },
        ]
      },
      {
        title: "项目信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "input",
            disabled: true,
            tip: "项目登记时的项目名称",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            },
            width: "50%",
          },
          {
            label: "招标项目名称：",
            value: "tenderPrjName",
            type: "input",
            maxlength: 500,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            },
            width: "50%",
          },
          {
            label: "招标类别：",
            value: "tenderClassNum",
            type: "select",
            width: "50%",
            clearable: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510200918460003"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标内容：",
            value: "tenderContentNum",
            type: "select",
            width: "50%",
            clearable: true,
            queryParams: {
              url: "/tenderContent/TenderContentCombobox",
              tenderClassNum: "",
              flag: "1"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标方式：",
            value: "tenderTypeNum",
            type: "select",
            width: "50%",
            clearable: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131544540011"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标组织形式：",
            value: "tenderMethod",
            type: "select",
            clearable: true,
            disabled: true,
            tip: "该项为选择项目后自动获取",
            optionData: [
              { name: "自行组织", value: "1" },
              { name: "委托代理", value: "2" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标项目类型：",
            value: "tenderProjectType",
            type: "select",
            width: "50%",
            clearable: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201904021418230002"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标项目行业分类编码：",
            value: "tenderPrjIndustriesType",
            type: "select",
            clearable: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201904021457570002"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "标段数/采购包：",
            value: "sectionQuantity",
            type: "slot",
            slotName: "sectionQuantity",
            width: "50%",
            rule: {
              type: "number",
              required: true,
              message: "请填写正确的数字！",
              trigger: ['blur', 'change']
            },
          },
          {
            label: "对投标人资格审查方式：",
            value: "prequalificationType",
            type: "select",
            clearable: true,
            tip: "审查方式为资格预审时，请在制作招标文件时设置评标办法。",
            optionData: [
              { name: "资格预审", value: "1" },
              { name: "资格后审", value: "2" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "资格预审办法：",
            value: "prequalificationMethod",
            type: "select",
            clearable: true,
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510200938040012"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "图审合格书编号：",
            value: "figureReviewNo",
            type: "input",
            maxlength: 30,
            width: "50%",
          },
          {
            label: "施工图审查机构名称：",
            value: "censorCorpName",
            type: "input",
            maxlength: 40,
            width: "50%",
          },
          {
            label: "施工图审查机构社会信用代码：",
            value: "censorCorpCode",
            type: "input",
            maxlength: 18,
            width: "50%",
          },
          {
            label: "本次招标工程投资额（万元）：",
            value: "allInvest",
            type: "slot",
            slotName: "allInvest",
            width: "50%",
            rule: {
              type: "number",
              required: false,
              message: "请填写正确的数字！",
              trigger: "change"
            }
          },
          {
            label: "计划工期（日历天）：",
            value: "plannedPeriod",
            type: "number",
            width: "50%",
            rule: {
              type: "number",
              required: true,
              message: "请填写正确的数字！",
              trigger: "change"
            }
          },
          {
            label: "建筑面积：",
            value: "structureArea",
            type: "input",
            maxlength: 100,
            width: "50%",
          },
          {
            label: "立项批准文号：",
            value: "noteNumber",
            type: "input",
            maxlength: 30,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            }
          },
          {
            label: "项目审批文件名称：",
            value: "approvalName",
            width: "50%",
            maxlength: 100,
            type: "input",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "项目审批单位：",
            value: "approvalAuthority",
            width: "50%",
            maxlength: 100,
            type: "input",
             rule: {
               required: true,
               message: "该输入项不能为空",
               trigger: "blur"
             }
          },
          {
            label: "立项批准日期：",
            value: "noteDate",
            type: "date",
            width: "50%",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "单体总栋数：",
            value: "totalNumberBuildings",
            type: "slot",
            slotName: "totalNumberBuildings",
            width: "50%",
            rule: {
              type: "number",
              required: false,
              message: "请填写正确的数字！",
              trigger: ['blur', 'change']
            }
          },
          {
            label: "评标办法：",
            value: "evaluationMethod",
            type: "select",
            clearable: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201511101429230008"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否需要项目负责人/总监：",
            value: "isNeedPm",
            type: "select",
            disabled: false,
            clearable: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
            class: "isNeedPm"
          },
        ]
      },
    ];
  }
  // 企业登记信息 项目信息模块
  static projectInformationTwo() {
    return [
      {
        title: "项目信息",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "是否电子标：",
            value: "ebsFlag",
            type: "select",
            disabled: true,
            clearable: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否地铁项目：",
            value: "isGroup",
            type: "select",
            clearable: true,
            tip: "若选择是，评审时将不进行分组评审",
            optionData: [
              { name: "否", value: "1" },
              { name: "是", value: "0" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "行政监督部门：",
            value: "regulators",
            type: "select",
            required: true,
            disabled: false,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201510311952460006"
            },
            class: "regulators"
          },
          {
            label: "项目容缺登记：",
            value: "projectVacancyRegistration",
            type: "select",
            clearable: true,
            tip: "项目资料齐全，请选择“否”，并将资料上传至平台；项目资料不完整，请选择“是”",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" }
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            },
          },
          {
            label: "资金性质：",
            value: "fundingSource",
            type: "select",
            clearable: true,
            disabled: false,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202406200912440647"
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标内容说明：",
            value: "tenderContentDescription",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "最多可填800个汉字",
            required: true,
            disabled: false,
          },
          {
            label: "质量要求：",
            value: "qualityRequirement",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "最多可填800个汉字",
            required: true,
            disabled: false,
          },
          {
            label: "资金落实情况：",
            value: "fundImplementation",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "最多可填800个汉字",
            required: true,
            disabled: false,
          },
          {
            label: "特殊情况说明：",
            value: "specialCaseDescription",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "最多可填800个汉字",
            required: true,
            disabled: false,
          },
          {
            label: "附件：",
            type: "slot",
            slotName: "uploadFile",
            tipContent: "填写完招标登记信息并保存后，请上传相关项目批准文件！",
            width: "100%;"
          },
        ]
      },
    ];
  }
  // 企业登记信息 招标信息
  static biddingInformation() {
    return [
      {
        title: "招标信息",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "招标人：",
            value: "tenderCorpName",
            width: "100%",
            tip: "根据项目登记自动生成，不需填写",
            disabled: true,
            type: "input",
          },
          {
            label: "招标联系人：",
            value: "tenderLinkMan",
            type: "input",
            maxlength: 50,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标联系人手机：",
            value: "tenderLinkPhone",
            type: "input",
            maxlength: 11,
            width: "50%",
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ]
          },
          // {
          //   label: "招标代理：",
          //   disabled: true,
          //   width: "100%",
          //   value: "agencyCorpName",
          //   tip: "根据招标代理备案自动生成，不需填写",
          //   type: "input",
          // },
          {
            label: "招标代理联系人：",
            value: "agencyLinkMan",
            type: "input",
            maxlength: 50,
            disabled: false,
            width: "50%",
            tip: "委托代理时必填",
          },
          {
            label: "招标代理手机：",
            value: "agencyLinkPhone",
            type: "input",
            maxlength: 11,
            disabled: false,
            width: "50%",
            tip: "委托代理时必填",
            rule: [
              {
                required: false,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ]
          },
          {
            label: "是否允许联合体下载：",
            value: "isUnionCorpEnroll",
            type: "select",
            clearable: true,
            required: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            },
          },
          {
            label: "招标单位是否联合体：",
            value: "isUnionTender",
            type: "select",
            clearable: true,
            required: true,
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            },
          },
          {
            label: "是否国有投资：",
            value: "nonstateInvestmentFlag",
            type: "select",
            clearable: true,
            required: true,
            optionData: [
              { name: "国有", value: "0" },
              { name: "非国有", value: "1" },
            ],
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: ['blur', 'change']
            },
          },
          {
            label: "联合体投标其它要求：",
            value: "associationRequirement",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 1000,
            tip: "最多可填1000个汉字",
            disabled: false,
          },
        ]
      },
      {
        title: "异议受理信息",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "异议受理部门名称：",
            value: "dissentDepartmentName",
            required: true,
            type: "input",
            maxlength: 100,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "异议受理部门地址：",
            value: "dissentDepartmentAddress",
            required: true,
            type: "input",
            maxlength: 300,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "异议受理部门联系人：",
            value: "dissentDepartmentLinkMan",
            required: true,
            type: "input",
            maxlength: 20,
              width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "异议受理部门联系人手机：",
            value: "dissentDepartmentLink",
            required: true,
            type: "input",
            maxlength: 11,
            width: "50%",
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ]
          },
          {
            label: "异议受理部门邮政编码：",
            value: "dissentPostalCode",
            required: true,
            type: "input",
            maxlength: 6,
            width: "50%",
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^[1-9][0-9]{5}$/,
                message: "输入的邮政编码不正确！",
              },
            ]
          },
          {
            label: "异议受理部门电子邮箱：",
            value: "dissentDepartmentEmail",
            required: true,
            type: "input",
            maxlength: 50,
            width: "50%",
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                message: "请输入格式正确的邮箱"
              }
            ]
          },
        ]
      },
    ];
  }
  // 企业登记信息 其他要求
  static otherRequirements() {
    return [
      {
        title: "其他要求",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "其它要求：",
            value: "otherRequirememts",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "最多可填800个汉字",
            disabled: false,
          },

        ]
      },
      {
        title: "备注",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "备注信息：",
            value: "description",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "（最多可填800个汉字）",
            disabled: false
          }
        ]
      },
      {
        title: "招标人意见",
        name: "7",
        icon: "",
        formConfigList: [
          {
            label: "招标人意见：",
            value: "tenderOpinion",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 500,
            disabled: true
          }
        ]
      },
      {
        title: "核验意见",
        name: "8",
        icon: "",
        formConfigList: [
          {
            label: "核验记录：",
            type: "slot",
            class: "list",
            slotName: "audit",
          },
        ]
      },
    ];
  }
}
